__turbopack_context__.v({
  "card": "OurJourney-module-scss-module__rF3Vqq__card",
  "cardButton": "OurJourney-module-scss-module__rF3Vqq__cardButton",
  "cardCta": "OurJourney-module-scss-module__rF3Vqq__cardCta",
  "cardEyebrow": "OurJourney-module-scss-module__rF3Vqq__cardEyebrow",
  "cardImage": "OurJourney-module-scss-module__rF3Vqq__cardImage",
  "cardInner": "OurJourney-module-scss-module__rF3Vqq__cardInner",
  "cardLockup": "OurJourney-module-scss-module__rF3Vqq__cardLockup",
  "cardTitle": "OurJourney-module-scss-module__rF3Vqq__cardTitle",
  "cards": "OurJourney-module-scss-module__rF3Vqq__cards",
  "cardsContainer": "OurJourney-module-scss-module__rF3Vqq__cardsContainer",
  "cardsContainerInner": "OurJourney-module-scss-module__rF3Vqq__cardsContainerInner",
  "cardsInView": "OurJourney-module-scss-module__rF3Vqq__cardsInView",
  "cardsScroll": "OurJourney-module-scss-module__rF3Vqq__cardsScroll",
  "copy": "OurJourney-module-scss-module__rF3Vqq__copy",
  "fade-in": "OurJourney-module-scss-module__rF3Vqq__fade-in",
  "header": "OurJourney-module-scss-module__rF3Vqq__header",
  "headline": "OurJourney-module-scss-module__rF3Vqq__headline",
  "isInView": "OurJourney-module-scss-module__rF3Vqq__isInView",
  "lockup": "OurJourney-module-scss-module__rF3Vqq__lockup",
  "root": "OurJourney-module-scss-module__rF3Vqq__root",
  "sticky": "OurJourney-module-scss-module__rF3Vqq__sticky",
});
